import editorTranslations from './editor/en';
import settingsTranslations from './settings/en';

export default {
    pages: {
        feedback: 'Feedback',
        disclaimer: 'Disclaimer',
        glossary: 'Help',
    },
    home: {
        infoBanner:
            'In the coming days, we will be changing the login procedure for werk-material.online. Please take note of the e-mail which you recently received from us.',
        title: 'At last – reliable cost data for all types of construction facility!',
        lead: 'Are you looking for a coherent collection of cost rates and benchmark data covering all facility types? Then the new werk-material.online web-based database will put you on a sound footing. Here you will find a comprehensive set of facts and figures backed up by informative statistical methods for the Swiss construction industry – straightforward, transparent and complete.',
        segments: {
            data: {
                title: 'Top-quality data as a solid foundation',
                lead: 'CRB draws on proven methodologies and benchmark data to set the standards for the Swiss building and real estate sectors. Structured by facility types and construction cost classifications (BCC, eCC-BC and eCC-CE), its tools pave the way for reliable costings, precise project specifications and streamlined processes. Every bit as helpful are the regular werk-material features in the werk, bauen + wohnen journal. Published since 1982, it collates useful data on all facility types to allow comparisons over an unrivalled period. All featured projects were selected by the editorial team according to strict quality criteria – yet another reason why werk, bauen + wohnen is generally acknowledged as the "gold standard" of Swiss Baukultur.',
            },
            analysis: {
                title: 'Intelligent analysis tools and unmatched data volume',
                lead: "Regardless of whether you are seeking intelligent analyses of individual projects or are more interested in the big picture: applied in tandem, the different statistical perspectives will provide valuable insights into all facility types. With over 750 datasets, werk-material.online offers a unique breadth and depth. werk, bauen + wohnen has complemented these with values supplied by the Swiss Federal Statistical Office (FSO) and additional projects from CRB's database.",
            },
            architecture: {
                title: 'Swiss architectural history as a bonus',
                lead: 'Moreover, by combining hard data with detailed project documentation, the werk-material.online portal casts a unique light on architecture in Switzerland. Direct project comparisons show, at a purely numeric level, what is needed to set standards and make a difference to the built environment.',
            },
        },
        'want-access': 'Would you like to have access to werk-material.online?',
        'register-here': 'Then register here and now!',
        'register-buy': 'Register & Buy',
    },
    register: {
        title: 'Welcome',
        'now-order-chargeable': 'Send order',
        'invoice-order': 'Payment by invoice',
        'checking-and-delivery':
            'After receiving your order, we will verify your details and send you an invoice by post within a week. Your subscription will be renewed automatically after one year.',
        register: 'Register',
        'login-info':
            'You need an account to buy the selected products. Please register and come back to this page after registration.<br/>If you already have an account, please log in. You will be redirected back to this page.',
        order: {
            title: 'Select product(s)',
            discount: {
                title: 'Discount',
                'new-customer': 'New Customer',
                'member-crb': 'CRB Member',
                'member-sia': 'SIA Member',
                'subscriber-work-bauen-und-wohnen': 'werk, bauen + wohnen Subscriber',
                'discount-code': 'Discount code',
            },
            'order-summary': 'Order Summary',
            'annual-fee': 'Annual cost',
            'applied-discount': '15% Discount',
            'net-total': 'Net Total',
            vat: '{{percentage}}% VAT',
            total: 'Total',
            promotion: 'Take advantage now of our promotional offers',
        },
        'data-collection': {
            dialog: {
                title: 'IMPORTANT NOTE FOR DATA COLLECTION:',
                description: {
                    title: '4.2 Zusätzliche Bestimmungen für die Nutzung der CRB-Web-Applikationen im Zusammenhang mit Daten von Anwendern ( AGB - CRB )',
                    content:
                        'CRB stellt registrierten Anwendern von einzelnen Web-Applikationen die Möglichkeit zur Verfügung, sich und/oder ihre Projekte und/oder Projektdaten CRB und/oder anderen registrierten Anwendern von CRB-Web-Applikationen anhand von auf den CRB-Web-Applikationen vorgegebenen Masken vorstellen zu können. Verschiedene CRB-Web-Applikationen stellen eine Kontakt- und Informationsplattform dar, welche es den registrierten Anwendern ermöglichen soll, Informationen über eigene Projekte zu verbreiten und Informationen über Projekte anderer Anwender zu erhalten sowie mit den anderen Anwendern in Kontakt zu treten und sich auszutauschen. Die Nutzung der CRB-Web-Applikationen setzt in der Regel eine Registrierung voraus. Bei der Registrierung kann der Anwender Angaben zu sich bzw. zu seinem Unternehmen und/oder seinen Projekten, teilweise einschliesslich Projektbeteiligten, machen, wobei die gemachten Angaben den tatsächlichen Gegebenheiten entsprechen und wahr sein müssen sowie die Veröffentlichung der Angaben im Einverständnis mit den Betroffenen und in Nachachtung der datenschutzrechtlichen Vorgaben erfolgen muss. CRB kann dafür keine Gewährleistung übernehmen und wird vom verantwortlichen Anwender, wenn Ansprüche gegen CRB geltend gemacht werden, vollumfänglich schad- und klaglos gehalten. CRB behält sich jedoch das Recht vor, unrichtige, unpassende, fehlerhafte und unwahre Angaben des Anwenders ohne Angabe von Gründen und ohne Information des Anwenders zu entfernen. Der gewählte Benutzername sowie das Passwort für den Zugang zu den CRB-Web-Applikationen sind geheim zu halten und dürfen insbesondere nicht registrierten Dritten nicht zugänglich gemacht werden. Die vom Anwender auf den CRB-Web-Applikationen gemachten Angaben über sich, sein Unternehmen sowie über seine Projekte können von CRB zur Errichtung und Zurverfügungstellung von weiteren Funktionen und/oder Angeboten uneingeschränkt verwendet werden. Insbesondere bei Webservices und Web-Applikationen die kostenlos genutzt werden können, werden die Angaben über die Projekte der Anwendenden wie, Daten, Modelle, Beschriebe, Klassifikationen usw., anonymisiert weiterverwertet und können von CRB nach Bedarf im eigenen Namen publiziert werden und/oder für die Zusammenstellung von Werten und/oder statistischen Auswertungen, die CRB im eigenen Namen publizieren kann, beigezogen. Ebenso können die von Anwender genannten Projektpartner von CRB eingeladen werden, sich ebenfalls auf den CRB-Web-Applikationen zu registrieren. Der Anwender darf, die von anderen Anwendern gemachten Angaben zu Projekten und Projektpartnern ausschliesslich zu Informations- und Kontaktzwecke nutzen. Jede weitergehende Verwendung der auf den CRB-Web-Applikationen verfügbaren Informationen und Daten ist nur mit schriftlicher vorgängiger Einwilligung von CRB gestattet.',
                },
                cancel: 'OK',
            },
        },
        userdata: {
            title: "User's data",
            email: 'E-Mail Address',
            password: 'Password',
            'repeat-password': 'Repeat Password',
            'immediate-access': 'Immediate access after registration',
            'after-order':
                'After receiving your order, we will immediately send you by e-mail your login details to werk-material.online.',
            'password-requirements': 'Password must be at least {{length}} characters long',
        },
        billing: {
            title: 'Billing Address',
            salutation: 'Title',
            company: 'Company',
            firstname: 'Name',
            lastname: 'Surname',
            phonenumber: 'Phone',
            street: 'Address',
            postofficebox: 'Post box number',
            postcode: 'ZIP',
            city: 'City',
            country: 'Country',
        },
        'accept-terms': 'I accept the general terms and conditions',
    },
    login: {
        title: 'Access to your account',
        'register-link': 'or create a new account',
        'forgot-password': 'Forgot password?',
        'reset-password-instruction':
            "Enter the email address you registered with here, and we'll send you a link to reset your password.",
    },
    'password-reset': {
        'forgot-password': 'Forgot password?',
    },
    'create-project': {
        project: 'Create project',
        estimation: 'eBKP-H Calculator',
        name: 'Project name',
        'cost-index': {
            date: 'Price level date',
            'greater-region': 'Greater region',
        },
        'submit-button': 'Create',
        error: 'Due to missing price data, projects from Lichtenstein are not supported.',
    },
    editor: editorTranslations,
    settings: settingsTranslations,
    feedback: {
        title: 'Feedback',
        'submit-feedback': 'Submit',
        'thank-you': 'Your request has been processed and you will shortly receive a confirmation email.',
        personal: {
            title: 'Personal Info',
            salutation: 'Salutation',
            firstname: 'First Name',
            lastname: 'Last Name',
            email: 'E-Mail',
        },
        report: {
            title: 'Feedback',
            topic: 'Topic',
            text: 'Text',
        },
    },
    customerService: {
        title: 'Customer Service Request',
        salutation: 'Salutation',
        firstname: 'First Name',
        lastname: 'Last Name',
        email: 'E-Mail',
        text: 'Text',
        'submit-customer-service-request': 'Submit',
        'thank-you': 'Your request has been processed and you will shortly receive a confirmation email.',
    },
    company: {
        'cooperation-partners': 'Partners',
        'customer-service': 'Customer Service',
    },
    account: {
        'change-password': {
            title: 'Change Password',
            instructions: 'Insert your current password and provide a new one.',
            'current-password': 'Current password',
            'new-password': 'New password',
            'repeat-new-password': 'Repeat new password',
            change: 'Change',
        },
    },
    salutation: {
        male: 'Mr',
        female: 'Ms',
    },
    navigation: {
        account: 'Account',
        'change-password': 'Change password',
        order: 'Select product(s)',
    },
    common: {
        yes: 'Yes',
        no: 'No',
        user: 'User',
        username: 'User name',
        'email-address': 'E-Mail Address',
        password: 'Password',
        login: 'Login',
        logout: 'Exit',
        remember: 'Remember me',
        confirm: 'Confirm',
        submit: 'Submit',
        close: 'Close',
        'processing-request': 'Processing your request. This may take several minutes',
        'do-not-reload': 'Please do not reload the page and be patient. Thank you very much.',
        'waiting-for-sync': 'Your order is currently being processed. Please bear with us for a short while.',
        'thank-you': 'Thank you!',
        editor: 'Editor',
        ok: 'OK',
        cancel: 'Cancel',
        continue: 'Continue',
        back: 'Back',
        add: 'Add',
        edit: 'Edit',
        pagination: {
            page: 'Page',
            next: 'Next',
            previous: 'Previous',
        },
    },
    errors: {
        'error-title': 'An error has occurred',
        'no-required-roles':
            'Sorry, an error has occurred. Please log out and log back in. If this does not help, please contact CRB at <a href="mailto:support@crb.ch">support@crb.ch</a>.',
        'login-data-wrong': 'Username or password wrong.',
        'service-unavailable': 'The server could not be reached.',
        'incomplete-form': 'The submitted form is incomplete, please check again.',
        'server-failed': 'The server cannot answer the request at the moment. Try again later.',
    },
    export: {
        language: 'Language',
        success: '{{count}} project was exported successfully',
        success_plural: '{{count}} projects were successfully exported',
        failed: '{{count}} project could not be exported',
        failed_plural: '{{count}} projects could not be exported',
    },
    import: {
        title: 'Import projects',
        text: 'Excel files with the correct format can be imported here.',
        areaText: 'Click here or drag the files onto this area.',
        success: '{{count}} project was imported successfully',
        success_plural: '{{count}} projects were successfully imported',
        failed: '{{count}} project could not be imported',
        failed_plural: '{{count}} projects could not be imported',
        errors: {
            upload: {
                failed: 'Upload failed',
            },
            import: {
                invalid: {
                    file: 'Invalid file format',
                    lang: 'Invalid or missing language',
                    name: 'Missing Name',
                    costIndexDate: 'Invalid or missing cost index date',
                    greaterRegion: 'Invalid or missing greater ragion',
                    buildingClass: 'Invalid or missing facility type werk-material',
                },
            },
        },
    },
    userinfo: {
        userEmail: 'Email',
        userId: 'User-ID',
        copy: {
            click: 'Click to copy',
            clicked: 'Copied!',
        },
    },
    project: {
        transfer: {
            'dialog-title': 'Transfer Project',
            'dialog-title_plural': 'Transfer Projects',
            content:
                'Enter the ID of the recipient and click Transfer.\n\nAfter the transfer, the project will no longer be displayed in your project list!',
            content_plural:
                'Enter the ID of the recipient and click Transfer.\n\nAfter the transfer, the projects will no longer be displayed in their project list!',
            receiverId: 'Receiver ID',
            cancel: 'Cancel',
            confirm: 'Transfer',
        },
    },
    languages: {
        de: 'German',
        fr: 'French',
        it: 'Italian',
        en: 'English',
    },
};
